import store from "@/core/store";

export default function guest({ next, router }) {
    if (store.getters.isAuthenticated) {
        return router.push({ name: 'home' }).catch(()=>{});
    }

    return next();
}